import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import { BASE_API } from "../types/api-endpoints";

const SocketContext = React.createContext();

const SocketProvider = ({ children }) => {
  const ENDPOINT = BASE_API;
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const newSocket = io(ENDPOINT, {
      transports: ["polling", "flashsocket"],
    });
    setSocket(newSocket);
  }, []);
  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export { SocketContext, SocketProvider };
